// extracted by mini-css-extract-plugin
export default {"container":"Map_container__TiubY","title":"Map_title__uwbz5","image_container":"Map_image_container__X2PrL","image":"Map_image__roeNK","button":"Map_button__h6wFc"};